<template>
  <div class="relative inline-block text-left z-50">
    <button
      @click="toggleDropdown"
      class="inline-flex items-center justify-center rounded-lg bg-slate-700 px-4 py-2 text-sm font-medium text-white shadow ring-1 ring-white/10 hover:bg-slate-600"
    >
      <img :src="currentFlag" class="mr-2 h-4 w-4 rounded-full" alt="flag" />
      <span>{{ currentLang.toUpperCase() }}</span>
      <svg class="ml-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <div
      v-if="open"
      class="absolute right-0 mt-2 w-40 rounded-lg bg-slate-700 py-2 text-white shadow-lg ring-1 ring-black/10"
    >
      <button
        v-for="lang in languages"
        :key="lang.code"
        @click="changeLanguage(lang.code)"
        class="flex w-full items-center px-4 py-2 text-left text-sm hover:bg-slate-600"
      >
        <img :src="lang.flag" class="mr-2 h-4 w-4 rounded-full" alt="flag" />
        {{ lang.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

const assetPath = (path) => `${process.env.BASE_URL}${path}`;

const flagMap = {
  hy: assetPath("img/hy.43f349d9.svg"),
  en: assetPath("img/en.27509f90.svg"),
  ru: assetPath("img/ru.e32ad7ba.svg"),
};

export default {
  name: "LanguageSwitcher",
  setup() {
    const { locale } = useI18n();
    const open = ref(false);

    const languages = [
      { code: "hy", label: "Հայերեն", flag: flagMap.hy },
      { code: "en", label: "English", flag: flagMap.en },
      { code: "ru", label: "Русский", flag: flagMap.ru },
    ];

    const currentLang = computed(() => locale.value);
    const currentFlag = computed(() => flagMap[locale.value] || flagMap.hy);

    function toggleDropdown() {
      open.value = !open.value;
    }

    function changeLanguage(code) {
      locale.value = code;
      open.value = false;
    }

    return {
      open,
      languages,
      currentLang,
      currentFlag,
      toggleDropdown,
      changeLanguage,
    };
  },
};
</script>
